<script setup lang="ts">
import type { PropType } from 'vue';
import type { SidebarLinkModel } from '@/components/sidebar/interfaces/SidebarLinkModel';

const props = defineProps({
  link: {
    type: Object as PropType<SidebarLinkModel>,
    required: true
  }
});

const emit = defineEmits(['linkClick']);

const linkClick = () => {
  emit('linkClick', props.link.id);
};
</script>

<template>
  <a class="option-link" @click="linkClick" v-ripple>
    <FontAwesomeIcon :icon="[`${link.iconStyle}`, `${link.icon}`]"
      class="link-icon"/>
    <div class="link-text">
      {{ link.label }}
    </div>
  </a>
</template>

<style scoped lang="scss">
.option-link {
  min-width: 64px;
  display: flex;
  padding: 6px 20px 6px 8px;
  align-items: center;
  text-align: left;
  justify-content: flex-start;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  &:hover {
    background-color: hsla(0, 0%, 0%, 0.15);
  }
}
.link-icon {
  width: 1em;
  margin-right: 10px;
}
</style>
